<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"
    @ClickOnCheckButton="check" @ClickOnVerifyButton="verify"/>
    <basic-table
      v-if="archiveDB"
      :items="archiveDB"
      :fields="archiveDBFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      archiveDBFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'begin', label: this.$i18n.t('Start time'), sortable: true},
        {key: 'end', label: this.$i18n.t('End time'), sortable: true},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true}
      ],
      options: {
        isShowAddButton: true,
        isShowCheckButton: true,
        isShowVerifyButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    check () {
      let response = this.$store.dispatch('Settings/UPDATE_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    verify () {
      let response = this.$store.dispatch('Settings/VERIFY_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    showAdd () {
      let response = this.$store.dispatch('Settings/CREATE_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    archiveDB () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/ARCHIVE_DB']))
      for (let el of copy) {
        el.end = moment(Number(el.end) * 1000).format('DD-MM-YYYY HH:MM')
        el.begin = moment(Number(el.begin) * 1000).format('DD-MM-YYYY HH:MM')
        switch (el.status) {
          case 0:
            el.status = 'OK'
            break
          case 1:
            el.status = this.$i18n.t('Under verifying')
            break
          case 2:
            el.status = this.$i18n.t('Unable to repair')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_ARCHIVE_DB')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/archiveDB/main.vue